export const logsRoutes = {
    path: '',
    name: 'logs-main',
    rule: 'editor',
    component: () => import('@/layouts/Main.vue'),
    children: [
        {
            path: '/logs',
            name: 'logs',
            component: () => import('@/views/elds/logs/LogsView.vue'),
            meta: {
                breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'ELD' },
                    { title: 'Logs', active: true }
                ],
                pageTitle: 'Logs',
                rule: 'editor',
                no_scroll: true
            }
        },
        {
            path: '/logs-driver',
            name: 'logs-driver',
            component: () => import('@/views/elds/logs/LogsByDriverView.vue'),
            meta: {
                breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'ELD' },
                    { title: 'Logs by driver', active: true }
                ],
                pageTitle: 'Logs by driver',
                rule: 'editor',
                no_scroll: true
            }
        },
        {
            path: '/driver-logs/:id',
            name: 'logsdriver',
            component: () => import('@/views/elds/logs/LogDetailView.vue'),
            meta: {
                breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Logs', url: '/logs' },
                    { title: 'Driver', active: true }
                ],
                props: true,
                rule: 'editor'
            }
        },
        {
            path: '/daily-report/:id',
            name: 'daily-report',
            component: () => import('@/views/elds/logs/LogDailyReportView.vue'),
            meta: {
                breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Logs', url: '/logs' },
                    { title: 'Daily Report', active: true }
                ],
                rule: 'editor'
            }
        },
    ]
}
